/* eslint-disable */
import * as Types from '../../../../types';

import { gql } from '@apollo/client';
import { OfferTagsFragmentDoc } from '../../../../components/organisms/offer/OfferTags/OfferTags.generated';
import { FormattedCurrencyTextCurrencyFieldsFragmentDoc, FormattedCurrencyTextMoneyFieldsFragmentDoc } from '../../../../components/organisms/FormattedCurrencyText/FormattedCurrencyText.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferContentFragment = { __typename: 'Offer', id: string, name: string, overview?: string | null, subtitle?: string | null, cardImageUrl?: string | null, videoUrl?: any | null, status: Types.OfferStatus, isAccreditationRequired: boolean, fund: { __typename: 'Fund', id: string, blurb: string, isMarketplaceFund: boolean, assetStructure: Types.AssetStructure }, primaryDocument?: { __typename: 'RemoteAsset', id: string, url: string } | null, documents?: Array<{ __typename: 'Document', id: string, title: string, file: { __typename: 'RemoteAsset', id: string, url: string } }> | null, dataBlocks?: Array<{ __typename: 'OfferTableBlock', id: string, title: string, rows: Array<{ __typename: 'OfferTableBlockRow', name: string, value: string }> } | { __typename: 'OfferTextBlock', content: string, id: string, title: string }> | null };

export type OfferInvestFragment = { __typename: 'Offer', id: string, digitalSubscription: Types.OfferDigitalSubscription, pricePerUnit?: number | null, estimatedPricePerUnit?: number | null, fundsDeadline?: any | null, hideOffer?: boolean | null, totalUnitCountDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, minUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, maxUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, investor?: { __typename: 'OfferInvestor', hasRegisteredInterest: boolean, outstandingRequirementsToInvest: Array<Types.OutstandingRequirementToInvest>, allocationRequests: Array<{ __typename: 'AllocationRequest', id: string, status: Types.AllocationRequestStatus, created: any, unitCountDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, investingEntity: { __typename: 'InvestingEntity', id: string } }> } | null, fund: { __typename: 'Fund', id: string, name: string, unitPrecisionScale?: number | null, currency: { __typename: 'Currency', id: string, abbreviation: string, symbol: string, decimalSeparator: string, thousandsSeparator: string } } };

export type OfferQueryVariables = Types.Exact<{
  slug: Types.Scalars['ID'];
  skipSession?: Types.Scalars['Boolean'];
}>;


export type OfferQuery = { __typename: 'Query', offer?: { __typename: 'Offer', id: string, slug: string, name: string, overview?: string | null, subtitle?: string | null, cardImageUrl?: string | null, videoUrl?: any | null, digitalSubscription: Types.OfferDigitalSubscription, pricePerUnit?: number | null, estimatedPricePerUnit?: number | null, fundsDeadline?: any | null, hideOffer?: boolean | null, status: Types.OfferStatus, isAccreditationRequired: boolean, fund: { __typename: 'Fund', id: string, blurb: string, name: string, unitPrecisionScale?: number | null, isMarketplaceFund: boolean, assetStructure: Types.AssetStructure, currency: { __typename: 'Currency', id: string, abbreviation: string, symbol: string, decimalSeparator: string, thousandsSeparator: string } }, primaryDocument?: { __typename: 'RemoteAsset', id: string, url: string } | null, documents?: Array<{ __typename: 'Document', id: string, title: string, file: { __typename: 'RemoteAsset', id: string, url: string } }> | null, dataBlocks?: Array<{ __typename: 'OfferTableBlock', id: string, title: string, rows: Array<{ __typename: 'OfferTableBlockRow', name: string, value: string }> } | { __typename: 'OfferTextBlock', content: string, id: string, title: string }> | null, totalUnitCountDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, minUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, maxUnitsPerInvestmentDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, investor?: { __typename: 'OfferInvestor', hasRegisteredInterest: boolean, outstandingRequirementsToInvest: Array<Types.OutstandingRequirementToInvest>, allocationRequests: Array<{ __typename: 'AllocationRequest', id: string, status: Types.AllocationRequestStatus, created: any, unitCountDecimal: { __typename: 'FixedPointNumber', value: string, decimalPlaces: number }, investingEntity: { __typename: 'InvestingEntity', id: string } }> } | null } | null, session?: { __typename: 'Session', impersonatedBy?: { __typename: 'Admin', id: string } | null } | null };

export const OfferContentFragmentDoc = gql`
    fragment OfferContent on Offer {
  id
  ...OfferTags
  name
  overview
  subtitle
  cardImageUrl
  videoUrl
  fund {
    id
    blurb
  }
  primaryDocument {
    id
    url
  }
  documents {
    id
    title
    file {
      id
      url
    }
  }
  dataBlocks {
    id
    title
    ... on OfferTextBlock {
      content
    }
    ... on OfferTableBlock {
      rows {
        name
        value
      }
    }
  }
}
    ${OfferTagsFragmentDoc}`;
export const OfferInvestFragmentDoc = gql`
    fragment OfferInvest on Offer {
  id
  digitalSubscription
  pricePerUnit
  estimatedPricePerUnit
  totalUnitCountDecimal {
    value
    decimalPlaces
  }
  minUnitsPerInvestmentDecimal {
    value
    decimalPlaces
  }
  maxUnitsPerInvestmentDecimal {
    value
    decimalPlaces
  }
  fundsDeadline
  hideOffer
  investor {
    allocationRequests {
      id
      status
      created
      unitCountDecimal {
        value
        decimalPlaces
      }
      investingEntity {
        id
      }
    }
    hasRegisteredInterest
    outstandingRequirementsToInvest
  }
  fund {
    id
    name
    unitPrecisionScale
    currency {
      id
      ...FormattedCurrencyTextCurrencyFields
    }
  }
}
    ${FormattedCurrencyTextCurrencyFieldsFragmentDoc}`;
export const OfferDocument = gql`
    query Offer($slug: ID!, $skipSession: Boolean! = true) {
  offer(slug: $slug) {
    id
    slug
    ...OfferContent
    ...OfferInvest
  }
  session @skip(if: $skipSession) {
    impersonatedBy {
      id
    }
  }
}
    ${OfferContentFragmentDoc}
${OfferInvestFragmentDoc}`;

/**
 * __useOfferQuery__
 *
 * To run a query within a React component, call `useOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      skipSession: // value for 'skipSession'
 *   },
 * });
 */
export function useOfferQuery(baseOptions: Apollo.QueryHookOptions<OfferQuery, OfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
      }
export function useOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferQuery, OfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferQuery, OfferQueryVariables>(OfferDocument, options);
        }
export type OfferQueryHookResult = ReturnType<typeof useOfferQuery>;
export type OfferLazyQueryHookResult = ReturnType<typeof useOfferLazyQuery>;
export type OfferQueryResult = Apollo.QueryResult<OfferQuery, OfferQueryVariables>;